import { z } from 'zod';

export const cryptoWithdrawalDetailsSchema = z.object({
  accountCurrency: z.string(),
  debit: z.string(),
  assetCurrency: z.string(),
  assetAmount: z.string(),
  estimatedNetworkFee: z.string(),
  estimatedReceived: z.string(),
  address: z.string(),
  tag: z.string().nullable(),
  actualFee: z.string().nullable().optional(),
  hash: z.string().nullable().optional(),
  failureReason: z.string().nullable().optional(),
});

export type CryptoWithdrawalDetails = z.infer<typeof cryptoWithdrawalDetailsSchema>;
